import { Collapse, Tag } from "antd";
import React from "react";
import "./view.scss";
import { CloseCircleOutlined, FireOutlined, VideoCameraFilled  } from "@ant-design/icons";

const NewIcon = () => {
  return (
    <div className="video-new-badge">
      <Tag style={{borderRadius:3}} color="#0080cb"><VideoCameraFilled  /> 新着</Tag>
    </div>
  );
};

export default React.memo(NewIcon);
